import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import { Bar } from "react-chartjs-2";
import 'chartjs-plugin-datalabels'; 
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import Page from "../Page";

const genBranchData = () => {
  return {
    labels: ['Klang', 'Gombak', 'Subang Jaya', 'Langat', 'Shah Alam'],
    datasets: [
      {
        label: 'Branch',
        data: [13, 4, 5, 3, 24],
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  }
};
const genPaymentModeData = () => {
  return {
    labels: ['Cash', 'Credit Card', 'eWallet', 'Cheque', 'Others'],
    datasets: [
      {
        label: 'Payment Mode',
        data: [13, 10, 12, 1, 25],
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  }
};
const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

const Cancellation = () => (
  // <div style={{width:"100%"},{textAlign:"center"}}>
  //   <div className='header'>
  //     <h1 className='title'>Todays Collection</h1>
  //   </div>
  //   <div style={{width:"800px"}}>
  //     <Pie data={genPieData()} />
  //   </div>
  // </div>

  <Page title="Remittance Cancellation">
    <Row>
      <Col xl={6} lg={12} md={12}>
        <Card>
          <CardHeader>Cancellation By Branch</CardHeader>
          <CardBody>
            <Bar data={genBranchData()} options={options} />
          </CardBody>
        </Card>
      </Col>
      <Col xl={6} lg={12} md={12}>
        <Card>
          <CardHeader>Cancellation By Payment Mode</CardHeader>
          <CardBody>
            <Bar data={genPaymentModeData()} options={options} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Page>
);

export default Cancellation;



// WEBPACK FOOTER //
// ./src/components/reports/Cancellation.js